var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShinylogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 436,
    height: 448,
    viewBox: "0 0 436 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_3",
    x: 0,
    y: 52,
    width: 436,
    height: 356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_2",
    x: 0,
    y: 0,
    width: 436,
    height: 356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2",
    "data-name": "Gruppe 2",
    transform: "translate(9.098 6.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M192.84,26.135a19,19,0,0,1,32.32,0L400.073,309.008A19,19,0,0,1,383.913,338H34.087a19,19,0,0,1-16.16-28.992Z",
    transform: "translate(417.902 441.894) rotate(180)",
    fill: "#a43c84"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.1, -6.11)",
    filter: "url(#Polygon_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    d: "M192.84,26.135a19,19,0,0,1,32.32,0L400.073,309.008A19,19,0,0,1,383.913,338H34.087a19,19,0,0,1-16.16-28.992Z",
    transform: "translate(427 396) rotate(180)",
    fill: "#c94aa2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.1, -6.11)",
    filter: "url(#Polygon_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-2",
    "data-name": "Polygon 2",
    d: "M192.84,26.135a19,19,0,0,1,32.32,0L400.073,309.008A19,19,0,0,1,383.913,338H34.087a19,19,0,0,1-16.16-28.992Z",
    transform: "translate(427 344) rotate(180)",
    fill: "#f953c6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShinylogo);
export default __webpack_public_path__ + "static/media/shinylogo.147f21e4f58ecb344984ea389c3fbd98.svg";
export { ForwardRef as ReactComponent };